import axiosClient from "../axios/axiosClient";

export function getAuditTrails() {
  return axiosClient.get("/activity-logs");
}
